<template>
  <div class="neo-nav" data-aos="fade-down">
    <div class="neo-nav__logo" @click="$router.push({ name: 'home' })">
      <img :src="getWebsiteImage('neo-logo.png')" alt="neo" />
    </div>
    <div class="neo-nav__links">
      <ul>
        <li @click="scroll('how-it-works')">How it works</li>
        <li @click="scroll('faqs')">FAQs</li>
        <li @click="scroll('access')">Get Early Access</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "NeoNav",
  props: {
    showOnlyRoutes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    goToDashboard() {
      this.$router.push({ name: "home.index" });
    },
    scroll(section) {
      this.scrollType === "route"
        ? this.$router.push({ name: "website" })
        : this.$emit("scroll", section);
    },
  },
};
</script>

<style lang="scss">
.neo-nav {
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__logo {
    cursor: pointer;

    img {
      height: 80px;
    }
  }

  &__links {
    ul {
      list-style: none;
      display: flex;
      align-items: center;
      padding: 0;
      margin: 0;

      li,
      a {
        padding: 15px 30px;
        font-size: 1.125rem;
        color: #121212;
        cursor: pointer;
      }
    }
  }

  &__cta {
    padding: 15px 0 15px 25px;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    cursor: pointer;
    color: #121212;
    transition: color 0.25s ease-in;

    &:hover {
      color: var(--primary);
      transition: color 0.25s ease-in;
    }
  }
}

@media (max-width: 600px) {
  .neo-nav {
    height: 70px;

    &__links {
      ul li {
        display: none;
      }
    }
  }
}
</style>
